import React from 'react';
import {Link} from "react-router-dom";
const Navbar = () => {
  return (
    <div className='navContainer'>
        <nav className={`navbar navbar-expand-lg px-5`}>
            <div className="container-fluid nav" style={{height: 100}}>
                <div>
                {/* <a className="navbar-brand" href="/">JOBSFOUND</a> */}
                <Link className="navbar-brand" to="/">JOBSFOUND :<span style={{color:"red"}}>)</span></Link>
                </div>
                <div>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                            <Link className="nav-link footerLi navl" style={{marginLeft: 20}} aria-current="page" to="/discover">Discover</Link>
                            </li>
                            <li className="nav-item">
                            <Link className="nav-link footerLi" style={{marginLeft: 20}} aria-current="page" to="/seekers">For Job Seekers</Link>
                            </li>
                            <li className="nav-item">
                            <Link className="nav-link footerLi" style={{marginLeft: 20}} aria-current="page" to="/company">For Companies</Link>
                            </li>
                        </ul>
                        <Link to="/login"><button type="button" className="btn btn-outline-success login navbtn">Log In</button></Link>
                        <Link to="/signup"><button type="button" className="btn btn-outline-dark login navbtn">Sign Up</button></Link>
                        
                    </div>
                </div>
            </div>
        </nav>
    </div>
  )
}

export default Navbar